import { useRef, useState } from "react";
import { Outlet, useNavigate, Link } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Avatar } from "primereact/avatar";
import { OverlayPanel } from "primereact/overlaypanel";
import Sidebar from "../components/Sidebar";
import "../css/layouts/layout.css";
import "../css/Common/ui-buttons.css";
import { logoutUser } from "../context/authLogout";
import { useAuth } from "../context/AuthContext";
import CommonPopUp from "../components/Common/CommonPopUp";

export default function AuthenticatedLayout() {
    const profileRef = useRef(null);
    const menuRef = useRef(null);
    const navigate = useNavigate();
    const { user } = useAuth();
    const [showLogoutPopup, setShowLogoutPopup] = useState(false);
    const [loggingOut, setLoggingOut] = useState(false);
    const UserName = user?.UserName || "ADMIN";
    const FullName = user?.FullName || "";

    const handleLogout = async () => {
        setLoggingOut(true);
        await logoutUser(navigate);
        setLoggingOut(false);
    };

    const handleMenuNavigation = (path) => {
        navigate(path);
        menuRef.current.hide();
    };

    return (
        <div className="layout-root">
            <Sidebar />
            <div className="layout-main">
                <div className="topbar">
                    <div className="topbar-right">
                        <span className="p-input-icon-left search-box">
                            <i className="pi pi-search" />
                            <InputText placeholder="Search here..." />
                        </span>
                        <i className="pi pi-bell topbar-icon" />
                        <i className="pi pi-envelope topbar-icon" />
                        <i className="pi pi-bars topbar-icon d-none" onClick={(e) => menuRef.current.toggle(e)} />
                        <span className="profile-role topbar-username"> {UserName} </span>
                        <Avatar image="https://i.pravatar.cc/40" shape="circle" className="topbar-avatar" onClick={(e) => profileRef.current.toggle(e)} />

                        <OverlayPanel ref={profileRef} className="profile-dropdown" dismissable>
                            <div className="profile-header">
                                <span className="profile-role"> {UserName} </span>
                                <strong className="profile-name"> {FullName} </strong>
                            </div>

                            <div className="profile-menu">
                                <button className="profile-item"> My Profile </button>
                                <button className="profile-item"> Settings </button>
                                <button
                                    className="profile-item logout"
                                    onClick={() => {
                                        profileRef.current.hide();
                                        setShowLogoutPopup(true);
                                    }}
                                >
                                    Log Out
                                </button>
                            </div>
                        </OverlayPanel>
                    </div>
                </div>
                <div className="header-bg" />
                <div className="page-content"> <Outlet /> </div>
                <CommonPopUp
                    visible={showLogoutPopup}
                    onHide={() => setShowLogoutPopup(false)}
                    onConfirm={handleLogout}
                    title="Confirm Logout"
                    message="Are you sure you want to logout?"
                    confirmLabel="Logout"
                    cancelLabel="Cancel"
                    loading={loggingOut}
                    showCloseIcon={false}   
                />

            </div>
        </div>
    );
}
